module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "contents"
    }
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/cover"
    }
  }, [_vm._v("COVER")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/titlepage"
    }
  }, [_vm._v("TITLE PAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/copyright"
    }
  }, [_vm._v("COPYRIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter2",
    attrs: {
      "id": "id_1_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication",
      "id": "Ref_11936a"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "id_1_6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part001#Ref_11948",
      "id": "Ref_11948a"
    }
  }, [_c('strong', [_vm._v("PART ONE")])]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001#Ref_11918",
      "id": "Ref_11918a"
    }
  }, [_vm._v("DANCING ON CLOUDS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002#Ref_11921",
      "id": "Ref_11921a"
    }
  }, [_vm._v("YOU CAN GO IN NOW, BUT PLEASE DON’T")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter003#Ref_11798",
      "id": "Ref_11798a"
    }
  }, [_vm._v("FISH MARKET DREAMS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter004#Ref_11801",
      "id": "Ref_11801a"
    }
  }, [_vm._v("COLD TRENCHES")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter005#Ref_11804",
      "id": "Ref_11804a"
    }
  }, [_vm._v("THE TROUBLE WITH HARRY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006#Ref_11924",
      "id": "Ref_11924a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TIME IS NOT ON MY SIDE, AND NEVER WAS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007#Ref_11807",
      "id": "Ref_11807a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SORRY, CHARLIE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008#Ref_11810",
      "id": "Ref_11810a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DELIVERED")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009#Ref_11813",
      "id": "Ref_11813a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GARDEN OF ODIN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#Ref_11816",
      "id": "Ref_11816a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HAMSTER LIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011#Ref_11819",
      "id": "Ref_11819a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROTATIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012#Ref_11822",
      "id": "Ref_11822a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIVISION FOUR")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013#Ref_11825",
      "id": "Ref_11825a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OUTER OF OUTERS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014#Ref_11828",
      "id": "Ref_11828a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTER KARNAK")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#Ref_11927",
      "id": "Ref_11927a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A WORLD OF SHIT, WITH RAZOR BLADES")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016#Ref_11930",
      "id": "Ref_11930a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GHOSTS, DEAD PEOPLE, AND THINGS THAT NEVER WERE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017#Ref_11831",
      "id": "Ref_11831a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PAIR OF ACES")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018#Ref_11834",
      "id": "Ref_11834a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QUESTIONS NEVER ASKED")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019#Ref_11837",
      "id": "Ref_11837a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SORROW AND PITY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#Ref_11840",
      "id": "Ref_11840a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SITUATION THAT PREVAILS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021#Ref_11843",
      "id": "Ref_11843a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HORN AND IVORY, BLOOD AND BONE")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "part002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part002",
      "id": "toc-part002",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("PART TWO")])]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022#Ref_11846",
      "id": "Ref_11846a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLUTO AND BEYOND")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023#Ref_11849",
      "id": "Ref_11849a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RUNNING ON EMPTY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024#Ref_11852",
      "id": "Ref_11852a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTO THE WEIRD")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025#Ref_11855",
      "id": "Ref_11855a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SECRET WORLD OF PLANTS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026#Ref_11858",
      "id": "Ref_11858a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLOSER TO THE PALACE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter027#Ref_11861",
      "id": "Ref_11861a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERBIRTH")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter028#Ref_11864",
      "id": "Ref_11864a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REMEMBRANCE PAST")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter029#Ref_11867",
      "id": "Ref_11867a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WINTER DREAMS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter030#Ref_11870",
      "id": "Ref_11870a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DAYS OF FUTURE PAST")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter031#Ref_11873",
      "id": "Ref_11873a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLEEP OF REASON")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter032#Ref_11876",
      "id": "Ref_11876a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DELIVERY AND REJECTION")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter033#Ref_11879",
      "id": "Ref_11879a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEAVE NOTICE AT THE DOOR")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter034#Ref_11882",
      "id": "Ref_11882a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUN-PLANET")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter035#Ref_11885",
      "id": "Ref_11885a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANCIENT OF DAYS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter036#Ref_11888",
      "id": "Ref_11888a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LAST ENEMY")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter037#Ref_11891",
      "id": "Ref_11891a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LAST INSTAURATION")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter038#Ref_11894",
      "id": "Ref_11894a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LONG HAUL HOME")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter039#Ref_11897",
      "id": "Ref_11897a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARTIAN RETURN")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter040#Ref_11900",
      "id": "Ref_11900a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOME IS THE HUNTER")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter041#Ref_11903",
      "id": "Ref_11903a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOME FROM THE STARS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter042#Ref_11933",
      "id": "Ref_11933a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AND THE CHILD HOME FROM THE WARS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter043#Ref_11906",
      "id": "Ref_11906a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SBLM")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter044#Ref_11909",
      "id": "Ref_11909a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SAYONARA")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter045#Ref_11912",
      "id": "Ref_11912a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PUTTING ON FLESH")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "id_1_53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter046#Ref_11915",
      "id": "Ref_11915a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UPGRADES")])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix1",
    attrs: {
      "id": "toc-discover-page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/discoverpage"
    }
  }, [_vm._v("DISCOVER MORE")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-appendix001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXTRAS")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "toc-personblurb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/personblurb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEET THE AUTHOR")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "toc-teaser001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("THE ETERNITY WAR: PARIAH")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-h1",
    attrs: {
      "id": "toc-teaser002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/teaser002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PREVIEW OF "), _c('em', [_vm._v("THE CORPORATION WARS: DISSIDENCE")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "REF_11942"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/adcard#REF_11942",
      "id": "REF_11942a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALSO BY GREG BEAR")])]), _vm._v(" "), _c('li', {
    staticClass: "toc-appendix",
    attrs: {
      "id": "toc-praise"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/praise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAISE FOR "), _c('em', [_vm._v("THE WAR DOGS TRILOGY")])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "hidden-tag",
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden"
    }
  }, [_c('h1', [_vm._v("Navigation")]), _vm._v(" "), _c('ol', {
    staticClass: "none",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/chapter001"
    }
  }, [_vm._v("Begin Reading")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b833b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0